module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAACCAYAAAAqyZ49AAAAAXNSR0IArs4c6QAAALBJREFUKFNVzzFOgzEQhNFvbI8jSEPBAdJzHu7DQXME2gQkYy9a529SrEZe2d63+oT6ccH3E369Yb+dPX5vrhXPgUvB4O5CGzO6jNfEReElXCY7lbXwqtEz8xxgBV6ZKgY6sZrIN3q6hzCRs3Z1RIvgqi8oXOgvp3f/tG/7fvaoz8Aqe4ieKM0/L7UN3Ij5wCSSlR9HywEPYLFiHUAcBxzU41hoZ6ISlwsjB+Hdj7j+A9AsRJavUloQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/couponImg/line-left.png
// module id = PIru
// module chunks = 0